import React, { useRef } from 'react';
import {reduxForm, FormSection, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import SubmitButtons from './sections/SubmitButtons';
import {
    FORM_ATTACHMENTS_SECTION,
    FORM_TICKET_SECTION,
    FORM_NOTES_SECTION,
    FORM_ORDERS_SECTION,
    FORM_CAR_REQUEST_SECTION,
    FORM_VEHICLE_DETAIL_SECTION,
    FORM_WAREHOUSE_SECTION, FORM_EDITORS_NOTES_SECTION_SP, FORM_SUPPLEMENTARY_INFORMATION_SECTION, FORM_LOAN_EXTENSION_SECTION,
    FORM_FIELD_AUTHORITY_GIVEN
} from '../../../../constants/formConstants';
import TicketStatusHistory from '../../../common/TicketStatusHistory';
import RenderSyncErrors from '../../../common/RenderSyncErrors';
import TicketSection from './sections/ticket/TicketSection';
import {scrollContentWrapperToTop} from '../../../../utils/utils';
import OrderItemsVorPviSection from './sections/orders/OrderItemsVorPviSection';
import NotesSection from './sections/notes/NotesSection';
import VehicleDetailPviSection from './sections/vehicleDetail/VehicleDetailPviSection';
import CarCourtesySection from './sections/carCourtesy/CarCourtesySection';
import WarehouseSection from './sections/warehouse/WarehouseSection';
import AttachmentSection from './sections/attachments/AttachmentSection';
import RenderDicValidations from './sections/orders/RenderDicValidations';
import formMessages from '../../../../intl/sparePartsOrders/formMessages';
import {sparePartsIntlFieldMapping} from '../../../../constants/sparePartsFieldLabelMapping';
import PropTypes from 'prop-types';
import BorderRadius from '../../../common/styled/BorderRadius';
import EditorsNotesSectionSP from './sections/editorsNotesSp/EditorsNotesSectionSP';
import InternalTicketReferences from './sections/ticketReferences/InternalTicketReferences';
import SupplementaryInformationSection from './sections/supplementaryInfo/SupplementaryInformationSection';
import { last } from 'lodash';
import get from 'get-value';

const VorPviOrderMasterForm = (props) => {
    const {form, userRights, reqFields, readOnly, handleSubmit, editMode, carRequestsSection, loanExtensionSection, warehouseSection } = props;
    const authorityGiven = get(warehouseSection, FORM_FIELD_AUTHORITY_GIVEN);
    const carRequests = get(carRequestsSection, 'carRequests', []);
    const dealerCarRequests = carRequests.filter(request => request.isDealer);
    const lastCarRequest = last(dealerCarRequests); // todo verify if we take only last one in account or any
    const warehousePriceRef = useRef(0);
    const warehouseDaysRef = useRef(0);

    return (
        <BorderRadius size={10} className="border border-dark p-4 bg-light">
            <RenderSyncErrors form={form} intlMessages={formMessages} mapping={sparePartsIntlFieldMapping}/>
            <RenderDicValidations/>
            <FormSection name={FORM_TICKET_SECTION}>
                <TicketSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_ORDERS_SECTION}>
                <OrderItemsVorPviSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_NOTES_SECTION}>
                <NotesSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_VEHICLE_DETAIL_SECTION}>
                <VehicleDetailPviSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <FormSection name={FORM_SUPPLEMENTARY_INFORMATION_SECTION}>
                <SupplementaryInformationSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            {!loanExtensionSection && <FormSection name={FORM_CAR_REQUEST_SECTION}>
                <CarCourtesySection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>}
            {(dealerCarRequests.some(request => request.carRequest === 'YES' || request.request === 'YES') || !!authorityGiven) &&
                <FormSection name={FORM_WAREHOUSE_SECTION}>
                    <WarehouseSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly} warehousePriceRef={warehousePriceRef} warehouseDaysRef={warehouseDaysRef}/>
                </FormSection>
            }
            {lastCarRequest && lastCarRequest.loanExtension === 'YES' &&
                <FormSection name={FORM_LOAN_EXTENSION_SECTION}>
                    <WarehouseSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly} loanExtension warehousePriceRef={warehousePriceRef} warehouseDaysRef={warehouseDaysRef}/>
                </FormSection>
            }
            {userRights.canReadEditorsNotes && 
                <FormSection name={FORM_EDITORS_NOTES_SECTION_SP}>
                    <EditorsNotesSectionSP form={form} userRights={userRights} readOnly={readOnly}/>
                </FormSection>
            }
            <InternalTicketReferences form={form} userRights={userRights}/>
            <FormSection name={FORM_ATTACHMENTS_SECTION}>
                <AttachmentSection form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}/>
            </FormSection>
            <TicketStatusHistory form={form}/>
            <SubmitButtons form={form} userRights={userRights} reqFields={reqFields} readOnly={readOnly}
                           onSubmit={handleSubmit} onSubmitFail={scrollContentWrapperToTop} editMode={editMode}/>
        </BorderRadius>
    )
};

VorPviOrderMasterForm.propTypes = {
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func,
    readOnly: PropTypes.bool,
    editMode: PropTypes.any,
    userRights: PropTypes.object.isRequired,
    reqFields: PropTypes.array.isRequired,
    dicInfo: PropTypes.object,
    carRequestsSection: PropTypes.object,
    loanExtension: PropTypes.object,
};

const mapStateToProps = (state, initialProps) => ({
    carRequestsSection: formValueSelector(initialProps.form)(state, `${FORM_CAR_REQUEST_SECTION}`),
    warehouseSection: formValueSelector(initialProps.form)(state, `${FORM_WAREHOUSE_SECTION}`),
});

export default connect(mapStateToProps)(reduxForm({})(VorPviOrderMasterForm));
